import { CyclewayIcon, DirectionStepIcon, ElevatorIcon, FerryIcon, FootwayIcon, GetOffTheBikeIcon, GetOnTheBikeIcon, GoStraightIcon, GreenwayIcon, LaneIcon, LivingStreetIcon, OppositeIcon, PrimaryRoadIcon, PrintableCyclewayIcon, PrintableDangerousRoadIcon, PrintableElevatorIcon, PrintableFerryIcon, PrintableFootwayIcon, PrintableGetOffTheBikeIcon, PrintableGetOnTheBikeIcon, PrintableGoStraightIcon, PrintableGreenwayIcon, PrintableLaneIcon, PrintableLivingStreetIcon, PrintableOppositeIcon, PrintableQuietRoadIcon, PrintableResidentialRoadIcon, PrintableRoundaboutIcon, PrintableSharedBuswayIcon, PrintableStairsIcon, PrintableStepIcon, PrintableThirtyKmsAreaIcon, PrintableTurnLeftIcon, PrintableTurnRightIcon, PrintableTurnSharpLeftIcon, PrintableTurnSharpRightIcon, PrintableTurnSlightLeftIcon, PrintableTurnSlightRightIcon, PrintableUTurnIcon, QuietRoadIcon, ResidentialRoadIcon, RoundaboutIcon, SharedBuswayIcon, StairsIcon, ThirtyKmsAreaIcon, TurnLeftIcon, TurnRightIcon, TurnSharpLeftIcon, TurnSharpRightIcon, TurnSlightLeftIcon, TurnSlightRightIcon, UTurnIcon } from '../components/icons';
export const instructionDirectionsMap = {
  dropSharedBike: {
    labelKey: 'commons.routing.directions.reach_station'
  },
  elevator: {
    labelKey: 'commons.routing.directions.take_elevator',
    Icon: ElevatorIcon,
    PrintableIcon: PrintableElevatorIcon
  },
  enterAgainstAllowedDirection: {
    labelKey: 'commons.routing.directions.take_no_entry'
  },
  getOffTheBike: {
    labelKey: 'commons.routing.directions.get_off_the_bike',
    Icon: GetOffTheBikeIcon,
    PrintableIcon: PrintableGetOffTheBikeIcon
  },
  getOnTheBike: {
    labelKey: 'commons.routing.directions.get_on_the_bike',
    Icon: GetOnTheBikeIcon,
    PrintableIcon: PrintableGetOnTheBikeIcon
  },
  goStraight: {
    labelKey: 'commons.routing.directions.go_straight',
    Icon: GoStraightIcon,
    PrintableIcon: PrintableGoStraightIcon
  },
  headOn: {
    labelKey: 'commons.routing.directions.head_on',
    Icon: GoStraightIcon,
    PrintableIcon: PrintableGoStraightIcon
  },
  stayOn: {
    labelKey: 'commons.routing.directions.stay_on',
    Icon: GoStraightIcon,
    PrintableIcon: PrintableGoStraightIcon
  },
  reachViaLocation: {
    labelKey: 'commons.routing.directions.reach_step',
    Icon: DirectionStepIcon,
    PrintableIcon: PrintableStepIcon
  },
  reachedTheStation: {
    labelKey: 'commons.routing.directions.reach_station'
  },
  reachedYourDestination: {
    labelKey: 'commons.routing.directions.reach_destination'
  },
  leaveRoundAbout: {
    labelKey: 'commons.routing.directions.leave_roundabout',
    Icon: RoundaboutIcon,
    PrintableIcon: PrintableRoundaboutIcon
  },
  roundAboutExit1: {
    labelKey: 'commons.routing.directions.leave_roundabout_at_1st_exit',
    Icon: RoundaboutIcon,
    PrintableIcon: PrintableRoundaboutIcon
  },
  roundAboutExit2: {
    labelKey: 'commons.routing.directions.leave_roundabout_at_2nd_exit',
    Icon: RoundaboutIcon,
    PrintableIcon: PrintableRoundaboutIcon
  },
  roundAboutExit3: {
    labelKey: 'commons.routing.directions.leave_roundabout_at_3rd_exit',
    Icon: RoundaboutIcon,
    PrintableIcon: PrintableRoundaboutIcon
  },
  roundAboutExit4: {
    labelKey: 'commons.routing.directions.leave_roundabout_at_4th_exit',
    Icon: RoundaboutIcon,
    PrintableIcon: PrintableRoundaboutIcon
  },
  roundAboutExit5: {
    labelKey: 'commons.routing.directions.leave_roundabout_at_5th_exit',
    Icon: RoundaboutIcon,
    PrintableIcon: PrintableRoundaboutIcon
  },
  roundAboutExit6: {
    labelKey: 'commons.routing.directions.leave_roundabout_at_6th_exit',
    Icon: RoundaboutIcon,
    PrintableIcon: PrintableRoundaboutIcon
  },
  roundAboutExit7: {
    labelKey: 'commons.routing.directions.leave_roundabout_at_7th_exit',
    Icon: RoundaboutIcon,
    PrintableIcon: PrintableRoundaboutIcon
  },
  roundAboutExit8: {
    labelKey: 'commons.routing.directions.leave_roundabout_at_8th_exit',
    Icon: RoundaboutIcon,
    PrintableIcon: PrintableRoundaboutIcon
  },
  roundAboutExit9: {
    labelKey: 'commons.routing.directions.leave_roundabout_at_9th_exit',
    Icon: RoundaboutIcon,
    PrintableIcon: PrintableRoundaboutIcon
  },
  roundAboutExit10: {
    labelKey: 'commons.routing.directions.leave_roundabout',
    Icon: RoundaboutIcon,
    PrintableIcon: PrintableRoundaboutIcon
  },
  roundAboutExit11: {
    labelKey: 'commons.routing.directions.leave_roundabout',
    Icon: RoundaboutIcon,
    PrintableIcon: PrintableRoundaboutIcon
  },
  roundAboutExit12: {
    labelKey: 'commons.routing.directions.leave_roundabout',
    Icon: RoundaboutIcon,
    PrintableIcon: PrintableRoundaboutIcon
  },
  roundAboutExit13: {
    labelKey: 'commons.routing.directions.leave_roundabout',
    Icon: RoundaboutIcon,
    PrintableIcon: PrintableRoundaboutIcon
  },
  roundAboutExit14: {
    labelKey: 'commons.routing.directions.leave_roundabout',
    Icon: RoundaboutIcon,
    PrintableIcon: PrintableRoundaboutIcon
  },
  roundAboutExit15: {
    labelKey: 'commons.routing.directions.leave_roundabout',
    Icon: RoundaboutIcon,
    PrintableIcon: PrintableRoundaboutIcon
  },
  roundAboutExit16: {
    labelKey: 'commons.routing.directions.leave_roundabout',
    Icon: RoundaboutIcon,
    PrintableIcon: PrintableRoundaboutIcon
  },
  roundAboutExit17: {
    labelKey: 'commons.routing.directions.leave_roundabout',
    Icon: RoundaboutIcon,
    PrintableIcon: PrintableRoundaboutIcon
  },
  roundAboutExit18: {
    labelKey: 'commons.routing.directions.leave_roundabout',
    Icon: RoundaboutIcon,
    PrintableIcon: PrintableRoundaboutIcon
  },
  roundAboutExit19: {
    labelKey: 'commons.routing.directions.leave_roundabout',
    Icon: RoundaboutIcon,
    PrintableIcon: PrintableRoundaboutIcon
  },
  roundAboutExit20: {
    labelKey: 'commons.routing.directions.leave_roundabout',
    Icon: RoundaboutIcon,
    PrintableIcon: PrintableRoundaboutIcon
  },
  roundAboutExitX: {
    labelKey: 'commons.routing.directions.leave_roundabout',
    Icon: RoundaboutIcon,
    PrintableIcon: PrintableRoundaboutIcon
  },
  turnLeft: {
    labelKey: 'commons.routing.directions.turn_left',
    Icon: TurnLeftIcon,
    PrintableIcon: PrintableTurnLeftIcon
  },
  turnRight: {
    labelKey: 'commons.routing.directions.turn_right',
    Icon: TurnRightIcon,
    PrintableIcon: PrintableTurnRightIcon
  },
  turnSharpLeft: {
    labelKey: 'commons.routing.directions.turn_sharp_left',
    Icon: TurnSharpLeftIcon,
    PrintableIcon: PrintableTurnSharpLeftIcon
  },
  turnSharpRight: {
    labelKey: 'commons.routing.directions.turn_sharp_right',
    Icon: TurnSharpRightIcon,
    PrintableIcon: PrintableTurnSharpRightIcon
  },
  turnSlightLeft: {
    labelKey: 'commons.routing.directions.turn_slight_left',
    Icon: TurnSlightLeftIcon,
    PrintableIcon: PrintableTurnSlightLeftIcon
  },
  turnSlightRight: {
    labelKey: 'commons.routing.directions.turn_slight_right',
    Icon: TurnSlightRightIcon,
    PrintableIcon: PrintableTurnSlightRightIcon
  },
  uTurn: {
    labelKey: 'commons.routing.directions.make_u_turn',
    Icon: UTurnIcon,
    PrintableIcon: PrintableUTurnIcon
  },
  unknown: {
    labelKey: 'commons.routing.directions.unknown'
  }
};
export const instructionFacilitiesMap = {
  cycleway: {
    labelKey: 'commons.facilities.cycleway',
    Icon: CyclewayIcon,
    PrintableIcon: PrintableCyclewayIcon
  },
  ferry: {
    labelKey: 'commons.facilities.ferry',
    Icon: FerryIcon,
    PrintableIcon: PrintableFerryIcon
  },
  footway: {
    labelKey: 'commons.facilities.footway',
    Icon: FootwayIcon,
    PrintableIcon: PrintableFootwayIcon
  },
  greenway: {
    labelKey: 'commons.facilities.greenway',
    Icon: GreenwayIcon,
    PrintableIcon: PrintableGreenwayIcon
  },
  lane: {
    labelKey: 'commons.facilities.lane',
    Icon: LaneIcon,
    PrintableIcon: PrintableLaneIcon
  },
  livingstreet: {
    labelKey: 'commons.facilities.living_street',
    Icon: LivingStreetIcon,
    PrintableIcon: PrintableLivingStreetIcon
  },
  opposite: {
    labelKey: 'commons.facilities.opposite',
    Icon: OppositeIcon,
    PrintableIcon: PrintableOppositeIcon
  },
  pedestrian: {
    labelKey: 'commons.facilities.pedestrian',
    Icon: FootwayIcon,
    PrintableIcon: PrintableFootwayIcon
  },
  primary: {
    labelKey: 'commons.facilities.primary',
    Icon: PrimaryRoadIcon,
    PrintableIcon: PrintableDangerousRoadIcon
  },
  residential: {
    labelKey: 'commons.facilities.residential_road',
    Icon: ResidentialRoadIcon,
    PrintableIcon: PrintableResidentialRoadIcon
  },
  secondary: {
    labelKey: 'commons.facilities.secondary',
    Icon: PrimaryRoadIcon,
    PrintableIcon: PrintableDangerousRoadIcon
  },
  service: {
    labelKey: 'commons.facilities.quiet_road',
    Icon: QuietRoadIcon,
    PrintableIcon: PrintableQuietRoadIcon
  },
  sharebusway: {
    labelKey: 'commons.facilities.shared_busway',
    Icon: SharedBuswayIcon,
    PrintableIcon: PrintableSharedBuswayIcon
  },
  steps: {
    labelKey: 'commons.facilities.stairs',
    Icon: StairsIcon,
    PrintableIcon: PrintableStairsIcon
  },
  tertiary: {
    labelKey: 'commons.facilities.tertiary',
    Icon: PrimaryRoadIcon,
    PrintableIcon: PrintableDangerousRoadIcon
  },
  zone30: {
    labelKey: 'commons.facilities.30kms_area',
    Icon: ThirtyKmsAreaIcon,
    PrintableIcon: PrintableThirtyKmsAreaIcon
  }
};
export const instructionOrientationsMap = {
  E: {
    labelKey: 'commons.routing.orientations.east'
  },
  N: {
    labelKey: 'commons.routing.orientations.north'
  },
  NE: {
    labelKey: 'commons.routing.orientations.north_east'
  },
  NW: {
    labelKey: 'commons.routing.orientations.north_west'
  },
  S: {
    labelKey: 'commons.routing.orientations.south'
  },
  SE: {
    labelKey: 'commons.routing.orientations.south_east'
  },
  SW: {
    labelKey: 'commons.routing.orientations.south_west'
  },
  W: {
    labelKey: 'commons.routing.orientations.west'
  }
};